// Auto-generated cornerstone translation for fr.
// Source: cornerstones/nl.js, translated via Claude Sonnet on 2026-05-28T13:32:59.627040+00:00.

export const CORNERSTONES = {
  beste: {
    seo: {
      title: "Application gestion chevaux : meilleur choix 2026 | EquiSight",
      description: "Comparez les applications de gestion équine pour propriétaire, écurie et élevage. Découvrez pourquoi EquiSight est l'application complète pour votre cheval.",
      keywords: [
        "application gestion chevaux",
        "application gestion écurie",
        "carnet de bord cheval application",
        "app pour gérer plusieurs chevaux",
        "application gestation jument",
        "application élevage chevaux",
        "meilleure application gestion chevaux",
      ],
    },
    hero: {
      eyebrow: "Guide de choix · logiciel de gestion équine",
      breadcrumbLabel: "Application gestion chevaux",
      title: "Application gestion chevaux : le guide de choix complet pour propriétaires, écuries et élevages.",
      intro: "Pas simplement une liste de fonctionnalités — une comparaison honnête, un guide de choix et un regard sur ce qu'une application de gestion équine doit vraiment savoir faire en 2026. Pour un seul cheval, pour toute une écurie, ou pour votre élevage.",
      pills: [
        {
          icon: "Users",
          label: "Pour les propriétaires",
        },
        {
          icon: "Building2",
          label: "Pour les écuries",
        },
        {
          icon: "Baby",
          label: "Pour les élevages",
        },
        {
          icon: "Share2",
          label: "Pour les équipes",
        },
      ],
      ctas: [
        {
          label: "Commencer gratuitement avec 1 cheval",
          href: "#start",
          primary: true,
        },
        {
          label: "Voir le tableau comparatif",
          href: "#vergelijking",
        },
      ],
    },
    pains: {
      title: "Pourquoi une application de gestion équine devient de plus en plus indispensable.",
      lead: "La gestion équine est en pratique très fragmentée : WhatsApp, agenda, Excel, photos sur le téléphone, passeport papier, factures séparées et engagements verbaux. Déjà peu pratique pour un seul cheval. Avec plusieurs chevaux, un élevage ou une prise en charge partagée, des lacunes apparaissent, des rendez-vous sont manqués et des discussions éclatent.",
      items: [
        "Quelle était déjà cette date de vaccination ?",
        "Qui a payé le maréchal-ferrant ?",
        "Quelle jument doit être contrôlée aujourd'hui ?",
        "L'entraîneur a-t-il bien lu les instructions de la semaine dernière ?",
        "Ai-je vraiment sauvegardé ce document photo ?",
        "Le plan d'alimentation affiché à l'écurie est-il encore à jour ?",
      ],
    },
    what: {
      title: "Qu'est-ce qu'une application de gestion équine ?",
      lead: "Une application de gestion équine est en substance un dossier numérique par cheval. Pas de notes dispersées, mais un seul endroit pour la santé, l'entraînement, l'alimentation, les documents, la planification, les rappels, les coûts, les photos, les vidéos et l'accès partagé. Toutes les personnes autour du cheval consultent les mêmes informations actualisées.",
      targetGroupsTitle: "À qui s'adresse une application de gestion équine ?",
      targetGroups: [
        {
          icon: "Heart",
          title: "Propriétaire particulier",
          body: "Un cheval, un dossier — santé, planning et historique dans votre poche.",
        },
        {
          icon: "Users",
          title: "Propriétaire de plusieurs chevaux",
          body: "Profils séparés, plannings séparés, liste de tâches partagée pour toute l'équipe.",
        },
        {
          icon: "Building2",
          title: "Pension & manège",
          body: "Accès propriétaire, instructions de soins, agenda partagé et tâches.",
        },
        {
          icon: "Baby",
          title: "Élevage",
          body: "Cycle des juments, gestation, données des étalons, généalogie et développement du poulain.",
        },
        {
          icon: "Target",
          title: "Entraîneurs",
          body: "Vue par cheval, enregistrement des séances, définition des objectifs, analyse des vidéos.",
        },
        {
          icon: "ClipboardList",
          title: "Professionnels",
          body: "Maréchal-ferrant, dentiste, kiné ou vétérinaire — travaillant depuis le même dossier.",
        },
      ],
    },
    criteria: {
      title: "Quels sont les critères d'une bonne application de gestion équine ?",
      lead: "Une application ne doit pas seulement être jolie — elle doit fonctionner de manière pratique au quotidien. Cinq éléments indispensables pour le choix 2026.",
      items: [
        {
          icon: "FileText",
          title: "Dossier par cheval",
          body: "Données, âge, race, informations du passeport, propriétaire, écurie, photos et documents — tous liés à un seul profil équin.",
        },
        {
          icon: "Heart",
          title: "Santé et soins",
          body: "Vaccinations, vermifugation, maréchal-ferrant, dentiste, vétérinaire, traitements, médication et rappels automatiques avant la date d'échéance.",
        },
        {
          icon: "Activity",
          title: "Entraînement et progression",
          body: "Enregistrement des séances, notes, vidéos, résultats de compétition, objectifs et progression par discipline ou par cheval.",
        },
        {
          icon: "Apple",
          title: "Alimentation et gestion",
          body: "Plans d'alimentation, compléments, fourrage grossier, poids, condition corporelle et la routine quotidienne que l'écurie doit connaître.",
        },
        {
          icon: "Share2",
          title: "Partage avec d'autres",
          body: "Accès pour le propriétaire, soigneur, entraîneur, responsable d'écurie ou professionnel — avec une gestion des droits adaptée au rôle de chacun.",
        },
        {
          icon: "Calendar",
          title: "Planification et rappels",
          body: "Un agenda partagé avec des tâches, des rappels automatiques et des confirmations pour que rien ne passe entre les mailles du filet.",
        },
      ],
    },
    comparison: {
      title: "EquiSight vs autres applications de gestion équine.",
      lead: "Le marché est actuellement occupé par Stalmanager, LogMyHorse, EquineM et Happie Horse. Chacun a ses points forts. Nous comparons les fonctionnalités les plus demandées, de façon honnête et sur la base d'informations publiquement disponibles.",
      competitors: [
        "EquiSight",
        "Stalmanager",
        "LogMyHorse",
        "EquineM",
        "Happie Horse",
      ],
      rows: [
        {
          label: "Démarrage gratuit",
          values: [
            true,
            true,
            true,
            false,
            true,
          ],
        },
        {
          label: "Plusieurs chevaux",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Dossier de santé",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Entraînement & progression",
          values: [
            true,
            false,
            true,
            true,
            true,
          ],
        },
        {
          label: "Alimentation & compléments",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Planification & rappels",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Documents par cheval",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Partage équipe & droits",
          values: [
            true,
            true,
            false,
            true,
            false,
          ],
        },
        {
          label: "Module élevage (complet)",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Cycle des juments",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Planification gestation + échographies",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Développement du poulain",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Intégration professionnels",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Insights EquiCoach",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Adapté aux propriétaires",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Adapté à l'élevage",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Adapté écurie/manège",
          values: [
            true,
            true,
            false,
            true,
            false,
          ],
        },
      ],
      note: "Comparaison basée sur les fonctionnalités publiquement disponibles en janvier 2026. Les concurrents sont également de bons outils ; EquiSight est conçu pour combiner tous les modules en une seule application.",
    },
    why: {
      title: "Pourquoi EquiSight est différent.",
      lead: "Un carnet de bord enregistre. EquiSight combine la gestion équine, l'entraînement, l'alimentation, la santé, les compétitions, les professionnels et l'élevage dans une seule application moderne — et va plus loin grâce aux insights.",
      points: [
        {
          icon: "Heart",
          title: "Une seule application pour toute la vie du cheval",
          body: "Du poulain au cheval de sport, jument reproductrice ou cheval à la retraite. Le dossier évolue avec votre cheval — rien ne se perd en chemin.",
        },
        {
          icon: "Sparkles",
          title: "Pas seulement des données, aussi des tendances",
          body: "EquiCoach combine développement, problèmes récurrents, entraînement et alimentation — pour que vous détectiez les signaux à temps, pas de simples alertes isolées.",
        },
        {
          icon: "Share2",
          title: "Conçu pour la collaboration",
          body: "Propriétaire, responsable d'écurie, entraîneur, maréchal-ferrant et autres professionnels travaillent depuis le même dossier équin — avec les droits correspondant à leur rôle.",
        },
      ],
    },
    nicheA: {
      eyebrow: "Niche · élevage",
      title: "Gestion équine pour les élevages.",
      lead: "De nombreux concurrents mentionnent l'élevage en une seule ligne. EquiSight a développé un module d'élevage complet — parce que l'éleveur est rarement l'utilisateur final d'une application généraliste, alors que sa planification est plus complexe que celle de quiconque.",
      items: [
        "Suivi quotidien du cycle des juments",
        "Date d'insémination + données de l'étalon",
        "Contrôle de gestation avec échographies",
        "Date de mise bas prévue + alertes",
        "Développement du poulain mois par mois",
        "Généalogie et filiation",
        "Notes par jument",
        "Vue d'ensemble de toutes les juments gestantes",
      ],
      ctaLabel: "Découvrir le module élevage",
      ctaHref: "/fokkerij",
    },
    nicheB: {
      eyebrow: "Niche · écurie & manège",
      title: "Gestion équine pour plusieurs chevaux et pensions.",
      lead: "Avec plusieurs chevaux, l'enjeu est moins la donnée que la communication. Chaque propriétaire a ses propres souhaits, routines, habitudes alimentaires et points d'attention médicaux. Chaque employé doit y accéder sans avoir à chercher.",
      cards: [
        {
          t: "Chevaux par propriétaire",
          d: "Chaque propriétaire ne voit que son ou ses chevaux.",
        },
        {
          t: "Instructions de soins",
          d: "Visibles par cheval pour l'écurie.",
        },
        {
          t: "Agenda partagé",
          d: "Maréchal-ferrant, vétérinaire et compétitions en une seule vue.",
        },
        {
          t: "Liste de tâches",
          d: "Assignées aux employés, avec confirmation.",
        },
        {
          t: "Accès propriétaire",
          d: "Les clients voient leur cheval dans leur propre application.",
        },
        {
          t: "Contacts d'urgence",
          d: "Toujours accessibles en cas de stress à l'écurie.",
        },
      ],
      ctaLabel: "Découvrir le module manège",
      ctaHref: "/manege-module",
    },
    beforeAfter: {
      title: "De WhatsApp, Excel et tableau blanc vers EquiSight.",
      lead: "Concrètement : voici comment votre gestion équine quotidienne se transforme.",
      rows: [
        {
          before: "Groupes WhatsApp",
          after: "Notes structurées par cheval",
        },
        {
          before: "Feuilles Excel",
          after: "Dossier équin en temps réel avec historique",
        },
        {
          before: "Tableau blanc à l'écurie",
          after: "Planning partagé sur votre téléphone",
        },
        {
          before: "Photos dispersées sur l'appareil photo",
          after: "Médias liés à votre cheval",
        },
        {
          before: "Engagements verbaux",
          after: "Tâches et rappels avec confirmation",
        },
        {
          before: "Passeport papier introuvable",
          after: "Documents toujours à portée de main",
        },
      ],
    },
    helper: {
      title: "Quelle application de gestion équine vous convient ?",
      lead: "Répondez à ces 5 questions et obtenez une recommandation honnête — même si ce n'est pas toujours EquiSight.",
      questions: [
        {
          id: "horses",
          q: "Avez-vous un seul cheval ou plusieurs chevaux ?",
          options: [
            {
              label: "Un seul cheval",
              score: 1,
            },
            {
              label: "2–5 chevaux",
              score: 2,
            },
            {
              label: "Plus de 5 chevaux",
              score: 3,
            },
          ],
        },
        {
          id: "clients",
          q: "Gérez-vous des chevaux appartenant à des clients ou à des tiers ?",
          options: [
            {
              label: "Non, uniquement mes propres chevaux",
              score: 0,
            },
            {
              label: "Parfois — pour la famille ou des connaissances",
              score: 1,
            },
            {
              label: "Oui, à titre professionnel (écurie / manège)",
              score: 3,
            },
          ],
        },
        {
          id: "breeding",
          q: "Souhaitez-vous suivre l'élevage et la gestation ?",
          options: [
            {
              label: "Non pertinent",
              score: 0,
            },
            {
              label: "Parfois — élevage occasionnel",
              score: 1,
            },
            {
              label: "Oui, je suis (ou serai) éleveur",
              score: 3,
            },
          ],
        },
        {
          id: "collab",
          q: "Collaborez-vous avec un entraîneur, un soigneur ou un professionnel ?",
          options: [
            {
              label: "Non, je fais tout moi-même",
              score: 0,
            },
            {
              label: "Oui, avec 1 personne",
              score: 1,
            },
            {
              label: "Oui, avec plusieurs personnes",
              score: 3,
            },
          ],
        },
        {
          id: "depth",
          q: "Voulez-vous seulement enregistrer ou aussi obtenir des insights ?",
          options: [
            {
              label: "Enregistrer uniquement",
              score: 1,
            },
            {
              label: "Enregistrer + planification",
              score: 2,
            },
            {
              label: "Enregistrer + planification + insights",
              score: 3,
            },
          ],
        },
      ],
      results: {
        low: {
          title: "Un simple carnet de bord suffit — et évolue avec vous.",
          body: "Pour un seul cheval sans soins partagés, toute application de gestion équine convient. EquiSight démarre gratuitement avec 1 cheval, donc sans risque. Si plus tard vous souhaitez ajouter plusieurs chevaux, un entraîneur ou un élevage, tout est déjà inclus.",
          cta: "Commencer gratuitement avec 1 cheval",
        },
        mid: {
          title: "EquiSight correspond bien à votre situation.",
          body: "Vous avez plusieurs besoins (plusieurs chevaux, collaboration ou insights). La plupart des concurrents couvrent 1 à 2 modules ; EquiSight les combine dans une seule application, sans connecter des outils séparés.",
          cta: "Découvrir ce que EquiSight peut faire",
        },
        high: {
          title: "EquiSight est le choix le plus logique.",
          body: "Votre situation combine plusieurs chevaux, collaboration, élevage et/ou insights. C'est précisément là qu'EquiSight fait la différence — pas d'outils fragmentés, mais un seul dossier équin pour tout et pour chacun autour du cheval.",
          cta: "Commencer gratuitement avec EquiSight",
        },
      },
    },
    faqTitle: "Questions fréquentes sur les applications de gestion équine",
    faq: [
      {
        q: "Quelle est la meilleure application de gestion équine ?",
        a: "La meilleure application de gestion équine dépend de votre situation. Pour un simple carnet de bord, plusieurs applications conviennent. Si vous souhaitez combiner santé, entraînement, alimentation, documents, élevage, planification et collaboration, EquiSight est conçu comme solution complète où tout se retrouve dans un seul dossier.",
      },
      {
        q: "Puis-je gérer plusieurs chevaux dans une seule application ?",
        a: "Oui. Une bonne application de gestion équine doit prendre en charge plusieurs chevaux, avec propriétaires, soigneurs, routines, documents, rendez-vous et rappels par cheval. EquiSight est conçu pour cela dès la première ligne de code — les chevaux sont des dossiers individuels, pas des lignes dans une liste.",
      },
      {
        q: "EquiSight est-il aussi adapté aux élevages ?",
        a: "Oui. EquiSight peut être configuré avec des fonctionnalités d'élevage telles que le cycle des juments, la date d'insémination, le suivi de gestation, les données des étalons, la généalogie, la date de mise bas prévue et le développement du poulain. C'est précisément le domaine où la plupart des applications concurrentes n'interviennent pas ou très peu.",
      },
      {
        q: "Puis-je partager des données avec mon entraîneur ou mon maréchal-ferrant ?",
        a: "Oui. L'objectif d'EquiSight est que les informations pertinentes puissent être partagées en toute sécurité avec les personnes autour du cheval — entraîneur, maréchal-ferrant, dentiste, vétérinaire, kiné, soigneur ou propriétaire. Chaque personne ne reçoit que les droits nécessaires à son rôle.",
      },
      {
        q: "Pourquoi ne pas simplement utiliser WhatsApp ou Excel ?",
        a: "WhatsApp et Excel fonctionnent tant que la situation reste simple. Dès que vous gérez plusieurs chevaux, rendez-vous, documents, traitements, propriétaires ou données d'élevage, les erreurs se multiplient : les informations se dispersent, les recherches prennent du temps et les engagements verbaux disparaissent. Une application de gestion équine centralise tout par cheval, avec des rappels automatiques.",
      },
      {
        q: "Combien coûte EquiSight ?",
        a: "Vous pouvez commencer gratuitement avec 1 cheval. Si vous souhaitez gérer plusieurs chevaux, activer l'élevage ou donner accès à des professionnels, des plans Premium abordables sont disponibles. Consultez les options actuelles sur la page des tarifs.",
      },
    ],
  },
  fokkerij: {
    seo: {
      title: "Logiciel d'élevage équin : comparaison complète 2026",
      description: "Comparez les logiciels d'élevage équin : cycle de la jument, gestation, choix de l'étalon et poulains. Découvrez pourquoi EquiSight est l'application d'élevage la plus complète.",
      keywords: [
        "logiciel élevage équin",
        "application cycle jument",
        "application gestation jument",
        "application enregistrement poulain",
        "application stud-book cheval",
        "planning saillie cheval",
        "application choix étalon",
      ],
    },
    hero: {
      eyebrow: "Guide de choix · logiciel d'élevage équin",
      breadcrumbLabel: "Logiciel d'élevage équin",
      title: "Logiciel d'élevage équin : la comparaison complète pour 2026.",
      intro: "Une jument poulinière mérite mieux qu'une application générique de gestion équine. Comparez les fonctionnalités d'élevage des outils les plus connus, découvrez ce qui compte vraiment, et choisissez en connaissance de cause le logiciel adapté à votre haras — grand ou petit.",
      pills: [
        {
          icon: "Baby",
          label: "Cycle de la jument",
        },
        {
          icon: "Heart",
          label: "Contrôle de gestation",
        },
        {
          icon: "Sparkles",
          label: "Développement du poulain",
        },
        {
          icon: "FileText",
          label: "Stud-book",
        },
      ],
      ctas: [
        {
          label: "Démarrer gratuitement avec le module élevage",
          href: "#start",
          primary: true,
        },
        {
          label: "Voir le tableau comparatif",
          href: "#vergelijking",
        },
      ],
    },
    pains: {
      title: "Pourquoi une application classique de gestion équine ne suffit pas pour l'élevage.",
      lead: "La plupart des applications équestres sont conçues pour un seul cheval de sport ou de loisir. L'élevage suit un rythme totalement différent : chaleurs, insémination, contrôle de gestation, échographies, calendrier des poulains, pedigree et vente. Un fichier Excel déraille au bout de 2 saisons — et avec plusieurs juments, vous perdez vite le fil.",
      items: [
        "C'était quand, le dernier cycle de Bonita déjà ?",
        "Quel étalon est prévu pour la saillie la saison prochaine ?",
        "L'échographie à 21 jours est-elle déjà planifiée ?",
        "Quels poulains de 2024 ont déjà été vendus ?",
        "Où se trouve le diagramme de pedigree jusqu'au grand-père maternel ?",
        "Où sont les prélèvements ADN et les données du passeport ?",
      ],
    },
    what: {
      title: "Qu'est-ce qu'un logiciel d'élevage équin ?",
      lead: "Un logiciel d'élevage est un dossier spécialisé par jument et par étalon, combiné à un calendrier annuel d'élevage, une planification de la gestation, l'enregistrement des poulains et l'affichage du pedigree. Pas un simple carnet équin générique, mais un outil qui comprend le cycle de reproduction : des premières chaleurs au sevrage.",
      targetGroupsTitle: "À quel type d'éleveur le logiciel d'élevage est-il destiné ?",
      targetGroups: [
        {
          icon: "Baby",
          title: "Éleveur amateur (1 à 3 juments)",
          body: "Une ou deux saillies par an — une vue d'ensemble sans jonglage avec Excel.",
        },
        {
          icon: "Building2",
          title: "Petit haras (4 à 10 juments)",
          body: "Un plan annuel d'élevage avec cycle, insémination, contrôles de gestation et dossier poulain.",
        },
        {
          icon: "Users",
          title: "Haras professionnel (10+)",
          body: "Plusieurs collaborateurs, choix de l'étalon par jument, vente et marketing.",
        },
        {
          icon: "Target",
          title: "Propriétaire d'étalon",
          body: "Historique des commandes, statistiques de semence et agenda par étalon.",
        },
        {
          icon: "Heart",
          title: "Transplantation embryonnaire",
          body: "Jument donneuse + receveuse en dossier couplé, calendrier TE.",
        },
        {
          icon: "ClipboardList",
          title: "Enregistrement au stud-book",
          body: "Prélèvements ADN, documents de passeport et données de pedigree.",
        },
      ],
    },
    criteria: {
      title: "Quels sont les critères d'un bon logiciel d'élevage ?",
      lead: "Toutes les « fonctionnalités d'élevage » d'une application équine ne se valent pas. Cinq domaines clés où les éleveurs perdent beaucoup de temps — et où un logiciel fait vraiment la différence.",
      items: [
        {
          icon: "Calendar",
          title: "Cycle de la jument et chaleurs",
          body: "Journal quotidien, prédiction de l'ovulation, report de cycle et rappels automatiques.",
        },
        {
          icon: "Heart",
          title: "Insémination et contrôle de gestation",
          body: "Dates de saillie et d'insémination, données de l'étalon, échographie à 14, 21 et 60 jours, et détermination du sexe.",
        },
        {
          icon: "Baby",
          title: "Développement du poulain",
          body: "Données de naissance, courbe de poids, calendrier de vermifugation, sevrage, enregistrement du passeport.",
        },
        {
          icon: "FileText",
          title: "Pedigree et documents",
          body: "Affichage du pedigree jusqu'à 4-5 générations, ADN, numéros de passeport et statut au stud-book.",
        },
        {
          icon: "Target",
          title: "Choix de l'étalon et matching",
          body: "Filtrage par discipline, lignées, données de l'étalon et succès historique — pas seulement ce que le propriétaire d'étalon met en avant.",
        },
        {
          icon: "Share2",
          title: "Collaboration vétérinaire/inséminateur",
          body: "Échographies, prélèvements et statuts partagés directement avec le praticien qui travaille avec vos juments.",
        },
      ],
    },
    comparison: {
      title: "EquiSight vs autres logiciels d'élevage équin.",
      lead: "Les résultats de recherche pour « logiciel d'élevage équin » affichent souvent des applications génériques qui mentionnent l'élevage en une phrase. Nous comparons honnêtement les outils qui disposent vraiment d'un flux d'élevage complet.",
      competitors: [
        "EquiSight",
        "Stalmanager",
        "HorseManager",
        "EquineGenie",
        "Foal-Excel",
      ],
      rows: [
        {
          label: "Démarrage gratuit",
          values: [
            true,
            true,
            false,
            false,
            true,
          ],
        },
        {
          label: "Journal du cycle de la jument",
          values: [
            true,
            false,
            true,
            true,
            true,
          ],
        },
        {
          label: "Date d'insémination + étalon",
          values: [
            true,
            false,
            true,
            true,
            true,
          ],
        },
        {
          label: "Échographies et contrôle de gestation",
          values: [
            true,
            false,
            true,
            true,
            false,
          ],
        },
        {
          label: "Date de poulinage prévue",
          values: [
            true,
            false,
            true,
            true,
            true,
          ],
        },
        {
          label: "Dossier poulain (poids/croissance)",
          values: [
            true,
            false,
            true,
            true,
            false,
          ],
        },
        {
          label: "Pedigree jusqu'à 4-5 générations",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "ADN et enregistrement du passeport",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Choix de l'étalon / matching",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "TE / transplantation embryonnaire",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Vue multi-juments",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Mobile (iOS/Android)",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "Partage avec le vétérinaire",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Intégré au dossier général",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "Vente et marketing des poulains",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
      ],
      note: "Comparaison basée sur les fonctionnalités publiquement disponibles en janvier 2026. EquineGenie est solide en élevage, mais moins performant en mobilité et en gestion équine générale. EquiSight combine les deux.",
    },
    why: {
      title: "Pourquoi EquiSight sert les éleveurs différemment.",
      lead: "De nombreux éleveurs utilisent un logiciel d'élevage distinct et une application séparée de gestion équine. EquiSight combine les deux — sans jongler entre applications ni saisir les données deux fois.",
      points: [
        {
          icon: "Heart",
          title: "La jument poulinière reste aussi un cheval ordinaire",
          body: "La jument poulinière dispose d'un dossier d'élevage ET d'un dossier équin complet — santé, vaccinations, maréchal-ferrant. Une seule application, tous les modules.",
        },
        {
          icon: "Sparkles",
          title: "Prédictif plutôt que réactif",
          body: "Prédiction du cycle, rappels des jalons de gestation et calendrier des poulains — automatiquement générés à partir de vos données.",
        },
        {
          icon: "Share2",
          title: "Tout l'entourage de l'élevage",
          body: "Inséminateur, propriétaire d'étalon, vétérinaire, acheteur, stud-book — tous ont accès avec les droits appropriés.",
        },
      ],
    },
    nicheA: {
      eyebrow: "Par discipline · du cycle au sevrage",
      title: "Ce que contient un dossier d'élevage dans EquiSight.",
      lead: "Chaque jument dispose d'un dossier d'élevage complet, lié à son dossier équin ordinaire.",
      items: [
        "Journal quotidien du cycle avec prédiction",
        "Insémination/saillie + données de l'étalon",
        "Chronologie des échographies (14/21/60 jours + sexe)",
        "Jalons de gestation avec rappels automatiques",
        "Date de poulinage prévue et préparation",
        "Dossier poulain dès la naissance",
        "Pedigree jusqu'aux grands-parents avec navigation cliquable",
        "Prélèvement ADN, passeport, statut au stud-book",
        "Pipeline de vente avec liste d'intéressés",
        "Historique des choix d'étalons par jument",
      ],
      ctaLabel: "Découvrir le module élevage",
      ctaHref: "/fokkerij",
    },
    nicheB: {
      eyebrow: "Pour l'ensemble du haras",
      title: "Vue d'ensemble pour plusieurs juments et étalons.",
      lead: "Dès que vous élevez plus de 2 à 3 juments, avoir une vue d'ensemble de tous les cycles et gestations devient indispensable.",
      cards: [
        {
          t: "Tableau de bord des cycles",
          d: "Toutes les juments côte à côte, avec le stade du cycle et la prochaine action.",
        },
        {
          t: "Pipeline de gestation",
          d: "Où en sont les juments dans les jalons de gestation ?",
        },
        {
          t: "Calendrier des poulains",
          d: "Naissances prévues par mois, avec la logistique adaptée en conséquence.",
        },
        {
          t: "Portefeuille d'étalons",
          d: "Étalons propres ou inséminateurs réguliers avec historique des commandes.",
        },
        {
          t: "Graphique de pedigree",
          d: "Analyse des ancêtres sur plusieurs générations et lignées.",
        },
        {
          t: "Tableau de bord des ventes",
          d: "Quels poulains sont vendus, réservés ou encore disponibles.",
        },
      ],
    },
    beforeAfter: {
      title: "D'Excel et d'un agenda à EquiSight élevage.",
      lead: "Concrètement : voici comment votre saison d'élevage change.",
      rows: [
        {
          before: "Cycle noté sur un bout de papier",
          after: "Journal quotidien avec prédiction",
        },
        {
          before: "Échographies envoyées par WhatsApp à l'inséminateur",
          after: "Dossier partagé avec photos",
        },
        {
          before: "Date de gestation dans l'agenda",
          after: "Rappels automatiques des jalons",
        },
        {
          before: "Passeport du poulain dans un tiroir",
          after: "Document lié au profil du poulain",
        },
        {
          before: "Pedigree sur papier",
          after: "Pedigree cliquable jusqu'à 4-5 générations",
        },
        {
          before: "Annonce de vente sur Marktplaats",
          after: "Pipeline de vente avec liste d'intéressés",
        },
      ],
    },
    helper: {
      title: "Quel logiciel d'élevage vous convient ?",
      lead: "5 questions pour déterminer si vous avez besoin d'une application d'élevage complète ou si un outil amateur suffit.",
      questions: [
        {
          id: "mares",
          q: "Combien de juments poulinières gérez-vous ?",
          options: [
            {
              label: "1 jument",
              score: 1,
            },
            {
              label: "2 à 5 juments",
              score: 2,
            },
            {
              label: "Plus de 5 juments",
              score: 3,
            },
          ],
        },
        {
          id: "frequency",
          q: "À quelle fréquence élevez-vous par an ?",
          options: [
            {
              label: "Occasionnellement (tous les quelques années)",
              score: 0,
            },
            {
              label: "1 à 2 saillies par an",
              score: 2,
            },
            {
              label: "3 saillies ou plus par an",
              score: 3,
            },
          ],
        },
        {
          id: "method",
          q: "Quelle méthode d'insémination/saillie utilisez-vous ?",
          options: [
            {
              label: "Saillie naturelle",
              score: 1,
            },
            {
              label: "IA semence fraîche/réfrigérée",
              score: 2,
            },
            {
              label: "TE ou semence congelée",
              score: 3,
            },
          ],
        },
        {
          id: "team",
          q: "Travaillez-vous avec un vétérinaire/inséminateur ?",
          options: [
            {
              label: "Une seule personne fixe",
              score: 1,
            },
            {
              label: "Plusieurs praticiens",
              score: 2,
            },
            {
              label: "Réseau international",
              score: 3,
            },
          ],
        },
        {
          id: "tracking",
          q: "Comment suivez-vous vos données actuellement ?",
          options: [
            {
              label: "Excel ou papier",
              score: 1,
            },
            {
              label: "Application générale de gestion équine",
              score: 2,
            },
            {
              label: "Aucun suivi structuré",
              score: 3,
            },
          ],
        },
      ],
      results: {
        low: {
          title: "Un outil amateur ou Excel suffit — mais EquiSight reste pratique.",
          body: "Pour 1 jument avec saillie naturelle tous les quelques années, un module d'élevage complet est superflu. EquiSight est gratuit au démarrage et vous activez le module d'élevage uniquement pour l'année où vous faites saillir — sans obligation de mise à niveau.",
          cta: "Démarrer gratuitement",
        },
        mid: {
          title: "EquiSight élevage est l'outil qu'il vous faut.",
          body: "Vous avez plusieurs juments ou plusieurs méthodes d'élevage — les applications équines génériques ne sont pas conçues pour cela. EquiSight combine élevage et soins généraux, afin que vous n'ayez pas à jongler entre deux outils.",
          cta: "Découvrir le module élevage",
        },
        high: {
          title: "EquiSight est conçu pour votre haras.",
          body: "Plusieurs juments, TE ou semence congelée, équipe internationale — la plupart des outils atteignent leurs limites ici. EquiSight monte en puissance jusqu'au niveau haras professionnel sans accumuler les licences.",
          cta: "Discutez avec nous d'un plan Haras",
        },
      },
    },
    faqTitle: "Questions fréquentes sur les logiciels d'élevage équin",
    faq: [
      {
        q: "Quel est le meilleur logiciel d'élevage pour chevaux ?",
        a: "Pour 1 jument sans méthode d'élevage complexe, de nombreux outils suffisent. À partir de 2 à 3 juments, avec recours à l'IA ou à la TE, ou en collaboration avec un vétérinaire et un stud-book, un module d'élevage complet devient indispensable. EquiSight combine l'élevage et la gestion équine générale dans une seule application, vous évitant tout changement d'outil.",
      },
      {
        q: "Quelles fonctionnalités d'élevage me sont vraiment nécessaires ?",
        a: "Au minimum : journal du cycle, données de saillie/insémination, jalons de contrôle de gestation et dossier poulain. En option mais très utile : affichage du pedigree, archive des choix d'étalons, ADN/passeport et pipeline de vente.",
      },
      {
        q: "EquiSight peut-il prédire le cycle d'une jument ?",
        a: "Oui. EquiSight utilise les données de cycles précédents pour afficher l'ovulation prévue, vous permettant de planifier l'insémination ou la saillie au bon moment — sans vous creuser la tête chaque jour.",
      },
      {
        q: "EquiSight fonctionne-t-il aussi pour la transplantation embryonnaire ?",
        a: "Oui. La jument donneuse et la receveuse disposent de dossiers couplés, d'un calendrier TE et de jalons partagés avec le praticien. Vous ne perdez ainsi aucune étape dans le flux complexe de la TE.",
      },
      {
        q: "Puis-je importer mes données d'élevage existantes ?",
        a: "Vous pouvez saisir manuellement les cycles, saillies et données des poulains, ou les importer en lot via CSV. Pour les élevages actifs disposant de données sur plusieurs saisons, nous vous aidons avec une migration unique.",
      },
      {
        q: "Comment partager un dossier avec mon vétérinaire ou mon inséminateur ?",
        a: "Chaque personne reçoit un accès avec un rôle défini : vétérinaire, inséminateur, propriétaire d'étalon ou responsable de stud-book. Chacun ne voit que les informations nécessaires à son rôle — sans accès complet requis.",
      },
    ],
  },
  manege: {
    seo: {
      title: "Logiciel de manège : comparatif complet & guide de choix 2026",
      description: "Comparez les logiciels de manège pour les cours, les cavaliers, les chevaux et l'administration. Découvrez quelle application convient à votre manège ou pension équestre.",
      keywords: [
        "logiciel de manège",
        "application gestion d'écurie",
        "logiciel administratif manège",
        "planification cours équitation",
        "logiciel pension équestre",
        "administration cavaliers",
        "administration chevaux manège",
      ],
    },
    hero: {
      eyebrow: "Guide de choix · logiciel de manège",
      breadcrumbLabel: "Logiciel de manège",
      title: "Logiciel de manège : le guide de choix complet pour manèges et pensions équestres.",
      intro: "Planification des cours, administration des cavaliers, gestion des chevaux, facturation et communication — un bon logiciel de manège rassemble tout en un seul endroit. Comparez les options les plus connues et découvrez celle qui correspond à votre écurie ou manège.",
      pills: [
        {
          icon: "Calendar",
          label: "Planification des cours",
        },
        {
          icon: "Users",
          label: "Cavaliers & clients",
        },
        {
          icon: "Heart",
          label: "Soins équins",
        },
        {
          icon: "CreditCard",
          label: "Facturation",
        },
      ],
      ctas: [
        {
          label: "Demander une démo",
          href: "#start",
          primary: true,
        },
        {
          label: "Voir le tableau comparatif",
          href: "#vergelijking",
        },
      ],
    },
    pains: {
      title: "Pourquoi des outils dispersés ralentissent un manège.",
      lead: "La plupart des manèges fonctionnent avec un patchwork d'outils : planification des cours sur un tableau blanc, registre des cavaliers dans Excel, facturation dans un second outil, soins des chevaux via WhatsApp et contact avec les propriétaires par messages personnels. En période chargée, cela entraîne des doubles réservations, des factures oubliées ou des chevaux dont personne ne sait quel cavalier ils accueillent.",
      items: [
        "Qui est en cours avec Jasmijn en ce moment ?",
        "Quel cavalier n'a pas encore payé pour mars ?",
        "Quel cheval ne doit pas être utilisé cette semaine ?",
        "Quels sont les contacts d'urgence des élèves ?",
        "Le propriétaire de Stardust a-t-il déjà reçu la facture du maréchal ?",
        "Quel cheval se trouve dans quel box ?",
      ],
    },
    what: {
      title: "Qu'est-ce qu'un logiciel de manège ?",
      lead: "Un logiciel de manège combine planification des cours, administration des cavaliers, gestion des chevaux, facturation et communication dans un seul outil. Fini les acrobaties Excel ou la jungle WhatsApp — un seul endroit où le manège fonctionne et où propriétaires et cavaliers peuvent suivre l'activité.",
      targetGroupsTitle: "Pour quel type d'entreprise est destiné un logiciel de manège ?",
      targetGroups: [
        {
          icon: "Building2",
          title: "Petit manège (1-15 chevaux)",
          body: "Avant tout planification des cours et paiements — une administration sans prise de tête.",
        },
        {
          icon: "Users",
          title: "Manège de taille moyenne (15-40 chevaux)",
          body: "Plusieurs instructeurs, planning des cours + emploi du temps des chevaux + administration des cavaliers.",
        },
        {
          icon: "ClipboardList",
          title: "Grande écurie de sport et de pension (40+)",
          body: "Exploitation complète incluant facturation, planification des repas et du maréchal.",
        },
        {
          icon: "Heart",
          title: "Pension équestre",
          body: "Portail propriétaire, instructions de soins individuelles, agenda partagé.",
        },
        {
          icon: "Target",
          title: "Écurie de formation saut d'obstacles",
          body: "Planification des concours, entraînement par cheval, contact client.",
        },
        {
          icon: "FileText",
          title: "Entrepreneurs hippiques",
          body: "Mélange de cours + pension + clinic + commerce — tout depuis un seul système.",
        },
      ],
    },
    criteria: {
      title: "Quels critères doit remplir un bon logiciel de manège ?",
      lead: "Une belle application ne vaut rien si vos employés ne souhaitent pas l'utiliser. Cinq critères pratiques qui font la différence entre succès et frustration.",
      items: [
        {
          icon: "Calendar",
          title: "Planification des cours à plusieurs niveaux",
          body: "Débutant/avancé, dressage/saut, associations cheval-cavalier et agendas des instructeurs — tous visibles côte à côte.",
        },
        {
          icon: "Users",
          title: "Administration des cavaliers",
          body: "Profils, niveau, abonnement, carnet de cours et liens familiaux pour les jeunes cavaliers.",
        },
        {
          icon: "Heart",
          title: "Planning des chevaux",
          body: "Quel cheval est utilisé et à quelle fréquence, avec les périodes de repos, blessure et récupération.",
        },
        {
          icon: "CreditCard",
          title: "Facturation & abonnements",
          body: "Abonnements mensuels, carnets de cours, cours individuels et prélèvement automatique.",
        },
        {
          icon: "Share2",
          title: "Portail propriétaire (pension équestre)",
          body: "Les propriétaires consultent leur cheval dans leur propre application — agenda, coûts, maréchal et notes sans appels téléphoniques.",
        },
        {
          icon: "Bell",
          title: "Communication & rappels",
          body: "Rappels de cours automatiques, notifications de paiement, annonces du maréchal — sans messagerie instantanée.",
        },
      ],
    },
    comparison: {
      title: "EquiSight vs autres logiciels de manège.",
      lead: "De nombreux outils pour manège sont performants en planification de cours ou en facturation, mais rarement en soins équins et en communication avec les propriétaires à la fois. Nous les comparons honnêtement.",
      competitors: [
        "EquiSight",
        "Stalmanager",
        "Equino",
        "Manege App",
        "Spreadsheet",
      ],
      rows: [
        {
          label: "Démarrage gratuit / période d'essai",
          values: [
            true,
            true,
            false,
            true,
            true,
          ],
        },
        {
          label: "Planification des cours",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Plusieurs instructeurs",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Administration des cavaliers",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Planning des chevaux",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "Soins équins (vaccins/maréchal)",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "Carnet de cours / abonnement",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Paiements en ligne",
          values: [
            true,
            true,
            true,
            false,
            false,
          ],
        },
        {
          label: "Facturation automatique",
          values: [
            true,
            true,
            true,
            false,
            false,
          ],
        },
        {
          label: "Portail propriétaire (pension)",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Intégration maréchal/vétérinaire",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Rappels WhatsApp/SMS",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "Mobile (iOS/Android)",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Planification des concours",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Adapté aux pensions équestres",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
      ],
      note: "Comparaison basée sur les fonctionnalités publiquement disponibles en janvier 2026. Stalmanager est performant en administration, EquiSight se distingue par son workflow pension + soins équins + portail propriétaire.",
    },
    why: {
      title: "Pourquoi EquiSight est différent pour les manèges et les pensions équestres.",
      lead: "EquiSight va plus loin qu'un simple planificateur de cours. Nous considérons un manège comme une exploitation complète : chevaux, personnes, communication et finances — tous interdépendants.",
      points: [
        {
          icon: "Heart",
          title: "Le cheval au centre, pas l'agenda",
          body: "Chaque cheval possède son propre dossier. Utilisation en cours, santé, maréchal et concours sur une seule chronologie — pas 3 outils séparés.",
        },
        {
          icon: "Share2",
          title: "Les propriétaires suivent sans appels téléphoniques",
          body: "Les propriétaires de pension ont leur propre vue : coûts, planning, photos et notes — économise 5 à 10 appels téléphoniques par semaine.",
        },
        {
          icon: "Bell",
          title: "Communication automatique",
          body: "Rappel de cours, rappel de vaccin, facture — automatiquement, via application/e-mail/SMS. Fini les messages WhatsApp en masse.",
        },
      ],
    },
    nicheB: {
      eyebrow: "Pour la pension équestre",
      title: "Ce qu'une pension équestre obtient avec EquiSight.",
      lead: "Les pensions équestres ont des défis uniques que les logiciels de manège classiques ne résolvent pas.",
      cards: [
        {
          t: "Portail propriétaire",
          d: "Chaque propriétaire voit uniquement son ou ses chevaux, l'agenda et les coûts.",
        },
        {
          t: "Instructions de soins par cheval",
          d: "Alimentation, fourrage, compléments, programme des couvertures — visible pour l'écurie.",
        },
        {
          t: "Agenda partagé",
          d: "Maréchal, vétérinaire et visites des propriétaires dans une seule vue.",
        },
        {
          t: "Frais de consommation par cheval",
          d: "Litière, fourrage, aliment concentré refacturés par propriétaire.",
        },
        {
          t: "Contacts d'urgence du cheval",
          d: "Propriétaire + vétérinaire + maréchal toujours accessibles pour l'écurie.",
        },
        {
          t: "Gestion des vacances",
          d: "Quels chevaux partent au pré, au repos ou en rééducation ?",
        },
      ],
    },
    beforeAfter: {
      title: "Du tableau blanc + Excel à EquiSight.",
      lead: "Concrètement : voilà comment une semaine de travail au manège se transforme.",
      rows: [
        {
          before: "Tableau blanc avec le planning des cours",
          after: "Planning en temps réel par instructeur",
        },
        {
          before: "Excel avec cavaliers + notes de cours",
          after: "CRM client avec historique des cours",
        },
        {
          before: "Messages WhatsApp aux propriétaires",
          after: "Portail propriétaire pour leur cheval",
        },
        {
          before: "Prélèvement mensuel manuel",
          after: "Facturation automatique + iDEAL",
        },
        {
          before: "Soins des chevaux sur un panneau d'affichage",
          after: "Instructions de soins par cheval, partagées",
        },
        {
          before: "Rendez-vous maréchal par accord verbal",
          after: "Planning maréchal avec confirmations",
        },
      ],
    },
    helper: {
      title: "Quel logiciel de manège vous convient ?",
      lead: "5 questions pour savoir si EquiSight est la bonne plateforme pour votre manège ou pension équestre.",
      questions: [
        {
          id: "size",
          q: "Combien de chevaux avez-vous dans votre établissement ?",
          options: [
            {
              label: "Moins de 10",
              score: 1,
            },
            {
              label: "10-30",
              score: 2,
            },
            {
              label: "Plus de 30",
              score: 3,
            },
          ],
        },
        {
          id: "type",
          q: "Quelle est votre activité principale ?",
          options: [
            {
              label: "Principalement donner des cours",
              score: 1,
            },
            {
              label: "Pension équestre (chevaux en pension)",
              score: 3,
            },
            {
              label: "Mélange de cours + pension",
              score: 3,
            },
          ],
        },
        {
          id: "instructors",
          q: "Avec combien d'instructeurs travaillez-vous ?",
          options: [
            {
              label: "Uniquement moi-même",
              score: 1,
            },
            {
              label: "2-3 instructeurs",
              score: 2,
            },
            {
              label: "4 ou plus",
              score: 3,
            },
          ],
        },
        {
          id: "billing",
          q: "Comment gérez-vous votre facturation actuellement ?",
          options: [
            {
              label: "Manuellement (Word/Excel)",
              score: 3,
            },
            {
              label: "Logiciel de comptabilité séparé",
              score: 2,
            },
            {
              label: "Intégré dans l'outil de cours",
              score: 1,
            },
          ],
        },
        {
          id: "owners",
          q: "Comment communiquez-vous avec les propriétaires ?",
          options: [
            {
              label: "En personne / WhatsApp",
              score: 3,
            },
            {
              label: "E-mail + WhatsApp",
              score: 2,
            },
            {
              label: "Portail propriétaire dans l'outil",
              score: 0,
            },
          ],
        },
      ],
      results: {
        low: {
          title: "Un outil léger ou Excel peut suffire pour l'instant — mais EquiSight évolue avec vous.",
          body: "Pour un petit établissement de cours avec un seul instructeur et peu de pension, un logiciel complet n'est pas immédiatement nécessaire. EquiSight démarre gratuitement et grandit avec votre manège — sans migration douloureuse dans quelques années.",
          cta: "Démarrer gratuitement",
        },
        mid: {
          title: "EquiSight est une mise à niveau logique pour votre manège.",
          body: "Plusieurs instructeurs, un mélange de cours et de pension, ou une facturation actuellement déconnectée — EquiSight regroupe tout en un seul flux de travail. Le portail propriétaire réduit considérablement la communication ad hoc.",
          cta: "Demander une démo",
        },
        high: {
          title: "EquiSight est conçu pour votre échelle.",
          body: "Pension équestre + cours + plusieurs instructeurs, c'est précisément là qu'EquiSight se distingue des logiciels de manège classiques. Le portail propriétaire et l'intégration des soins équins font économiser des heures d'administration et de communication chaque semaine.",
          cta: "Planifier une démo pour votre écurie",
        },
      },
    },
    faqTitle: "Questions fréquentes sur les logiciels de manège",
    faq: [
      {
        q: "Quel est le meilleur logiciel de manège ?",
        a: "Pour la planification de cours pure, plusieurs bonnes options existent. Dès que vous avez besoin d'une pension équestre, de plusieurs instructeurs ou du suivi des soins équins, EquiSight devient la solution complète — sans jonglage entre outils, tout au même endroit.",
      },
      {
        q: "Puis-je importer mes clients et cours existants ?",
        a: "Oui. Les données clients et les plannings de cours peuvent être importés via CSV. Nous accompagnons les manèges actifs avec une migration unique afin que vous n'ayez pas à saisir 200 cavaliers manuellement.",
      },
      {
        q: "Fonctionne-t-il aussi pour une pension équestre sans cours ?",
        a: "Oui. Le mode pension équestre désactive les cours et se concentre sur le portail propriétaire, l'alimentation et les soins, la planification du maréchal et la refacturation des coûts par cheval.",
      },
      {
        q: "Les cavaliers peuvent-ils s'inscrire et payer eux-mêmes ?",
        a: "Oui. Les cavaliers peuvent via leur propre compte consulter les cours disponibles, s'inscrire, payer les frais de cours avec iDEAL et acheter des carnets de cours.",
      },
      {
        q: "Qu'en est-il de la confidentialité des données des chevaux et des propriétaires ?",
        a: "Chaque personne dispose d'un rôle (propriétaire, cavalier, instructeur, employé). Par rôle, vous ne voyez que ce dont vous avez besoin. Les propriétaires voient uniquement leur cheval, les cavaliers uniquement leurs propres cours.",
      },
      {
        q: "EquiSight peut-il se connecter à mon logiciel de comptabilité ?",
        a: "Oui, des intégrations avec Exact, Moneybird et e-Boekhouden sont disponibles. Les factures sont alors transmises automatiquement à votre comptabilité.",
      },
    ],
  },
  trainer: {
    seo: {
      title: "Application entraîneur cheval : comparatif & guide de choix pour coachs 2026",
      description: "Comparez les applications entraîneur pour cheval et cavalier : journal d'entraînement, vidéo, objectifs, analyse de reprise et gestion des clients. Trouvez le bon outil pour les coachs.",
      keywords: [
        "application entraîneur cheval",
        "application instructeur équitation",
        "app entraînement cheval",
        "application coaching cavalier",
        "journal d'entraînement cheval",
        "analyser reprise dressage",
        "logiciel entraîneur équestre",
      ],
    },
    hero: {
      eyebrow: "Guide de choix · logiciel entraîneur",
      breadcrumbLabel: "Application entraîneur",
      title: "Application entraîneur cheval : guide de choix complet pour instructeurs et coachs.",
      intro: "Un entraîneur ou instructeur jongle avec des binômes, des cours, des vidéos, des objectifs et des concours. Comparez les meilleures applications entraîneur pour les passionnés d'équitation et choisissez la plateforme qui continuera à évoluer avec votre coaching en 2026.",
      pills: [
        {
          icon: "Target",
          label: "Objectifs & planification",
        },
        {
          icon: "Video",
          label: "Analyse vidéo",
        },
        {
          icon: "TrendingUp",
          label: "Progression",
        },
        {
          icon: "Users",
          label: "Clients/binômes",
        },
      ],
      ctas: [
        {
          label: "Commencer gratuitement en tant qu'entraîneur",
          href: "#start",
          primary: true,
        },
        {
          label: "Voir le tableau comparatif",
          href: "#vergelijking",
        },
      ],
    },
    pains: {
      title: "Pourquoi le coaching par WhatsApp freine les entraîneurs.",
      lead: "La plupart des entraîneurs travaillent avec des outils séparés : WhatsApp pour la communication, un carnet pour les cours, YouTube ou WeTransfer pour les vidéos et Excel pour les résultats de concours. Avec 5 cavaliers, ça fonctionne. Avec 20 cavaliers, les informations se perdent, les objectifs s'oublient et on perd le fil de la progression individuelle.",
      items: [
        "Où est noté l'objectif d'Anouk pour cette saison ?",
        "Quelle vidéo ai-je envoyée à Bram le mois dernier ?",
        "Lara a-t-elle vu l'analyse de reprise de son dernier concours ?",
        "Quel binôme s'entraîne combien de fois par semaine ?",
        "Le propriétaire de Stardust a-t-il lu mes instructions d'entraînement ?",
        "Quand ai-je donné pour la dernière fois un retour sur l'impulsion fluctuante ?",
      ],
    },
    what: {
      title: "Qu'est-ce qu'une application entraîneur pour cheval et cavalier ?",
      lead: "Une application entraîneur combine un CRM de coaching (binômes, cours, objectifs), un journal d'entraînement par cheval, un retour vidéo, la planification des concours et l'analyse de reprise. Plus de WhatsApp/YouTube/Excel séparés, mais une seule plateforme où entraîneur et cavalier travaillent ensemble.",
      targetGroupsTitle: "Pour quel type d'entraîneur est-ce conçu ?",
      targetGroups: [
        {
          icon: "Target",
          title: "Instructeur de dressage",
          body: "Scanner les reprises, associer les commentaires de jury aux objectifs d'entraînement, visualiser la progression.",
        },
        {
          icon: "Activity",
          title: "Entraîneur de saut d'obstacles",
          body: "Planification de parcours, retour par tour, gestion des hauteurs par cheval.",
        },
        {
          icon: "Award",
          title: "Coach de concours complet",
          body: "Trois disciplines, trois plannings — tous visibles côte à côte.",
        },
        {
          icon: "TrendingUp",
          title: "Coach de performance (sport)",
          body: "Suivi EPI, concours, objectifs — pour les sportifs de haut niveau et leurs équipes.",
        },
        {
          icon: "Users",
          title: "Instructeur de centre équestre",
          body: "Cours collectifs + coaching individuel dans une seule application.",
        },
        {
          icon: "Heart",
          title: "Coach récréatif",
          body: "Thérapie équestre, débutants, propriétaires avec un seul cheval.",
        },
      ],
    },
    criteria: {
      title: "Quels sont les critères d'une bonne application entraîneur ?",
      lead: "L'entraînement est une affaire humaine, mais le bon outil vous rend 30 à 50 % plus efficace et aide les cavaliers à progresser entre les cours.",
      items: [
        {
          icon: "Users",
          title: "Gestion des binômes",
          body: "Cheval + cavalier comme une seule unité, avec niveau, objectifs, progression et historique.",
        },
        {
          icon: "ClipboardList",
          title: "Notes de cours & objectifs",
          body: "Une note par cours avec les points de focus, liée aux objectifs à long terme.",
        },
        {
          icon: "Video",
          title: "Retour vidéo",
          body: "Importez une vidéo, marquez des moments clés, ajoutez un retour vocal ou écrit.",
        },
        {
          icon: "Target",
          title: "Analyse de concours & de reprise",
          body: "Scannez les reprises (KNHS/FEI), visualisez les scores par élément, les commentaires de jury et les tendances.",
        },
        {
          icon: "Calendar",
          title: "Planification & carnets de cours",
          body: "Agenda, paiements, abonnements et rappels automatiques.",
        },
        {
          icon: "Share2",
          title: "Communication vers le cavalier",
          body: "Le cavalier voit sa propre page avec cours, vidéos, objectifs et retours.",
        },
      ],
    },
    comparison: {
      title: "EquiSight vs autres applications entraîneur.",
      lead: "Certains outils pour entraîneurs se concentrent sur le remplacement de WhatsApp, d'autres sur l'analyse de reprise. EquiSight combine les deux avec un véritable dossier cheval — pour que le cavalier progresse aussi entre les cours.",
      competitors: [
        "EquiSight",
        "Coach Apps (algemeen)",
        "HorseTrainer Pro",
        "EquiPilot",
        "WhatsApp + Excel",
      ],
      rows: [
        {
          label: "Démarrage gratuit",
          values: [
            true,
            true,
            false,
            true,
            true,
          ],
        },
        {
          label: "Gestion des binômes",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Notes de cours & retours",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Objectifs à long terme",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Import vidéo + retour",
          values: [
            true,
            true,
            true,
            false,
            false,
          ],
        },
        {
          label: "Scan reprise KNHS/FEI",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "EPI (Indice de Performance)",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Calendrier de concours",
          values: [
            true,
            false,
            true,
            true,
            false,
          ],
        },
        {
          label: "Portail cavalier",
          values: [
            true,
            true,
            false,
            true,
            false,
          ],
        },
        {
          label: "Carnet de cours / abonnement",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Paiements en ligne",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Dossier cheval intégré",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Maréchal/vétérinaire visible",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Pour instructeur ET cavalier",
          values: [
            true,
            true,
            false,
            true,
            true,
          ],
        },
        {
          label: "Multi-chevaux par cavalier",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
      ],
      note: "Comparatif basé sur les fonctionnalités publiquement disponibles en janvier 2026. EquiSight est unique dans l'analyse de reprise + EPI et combine cela avec la gestion générale du cheval.",
    },
    why: {
      title: "Pourquoi EquiSight offre une expérience d'entraîneur différente.",
      lead: "La plupart des outils pour entraîneurs s'arrêtent là où le cours se termine. EquiSight continue — dans le dossier cheval, dans l'analyse de concours, dans la collaboration avec le vétérinaire et le propriétaire.",
      points: [
        {
          icon: "TrendingUp",
          title: "Scan de reprise → objectif d'entraînement",
          body: "Scannez une reprise KNHS et voyez immédiatement quels éléments nécessitent de l'attention. Les objectifs remontent automatiquement à la surface.",
        },
        {
          icon: "Sparkles",
          title: "EquiCoach renforce votre regard",
          body: "Les données de plusieurs cours, concours et reprises révèlent des tendances que vous ne pouvez pas garder en tête.",
        },
        {
          icon: "Share2",
          title: "Intégré au dossier cheval",
          body: "L'entraîneur voit les vaccins, le maréchal et l'historique de blessures du cheval — pour ne pas planifier d'entraînement pendant une convalescence.",
        },
      ],
    },
    nicheA: {
      eyebrow: "Pour le dressage et le saut d'obstacles",
      title: "Ce que contient un dossier de coaching dans EquiSight.",
      lead: "Chaque binôme dispose d'un fil de coaching qui regroupe tout — fini de perdre des informations dans WhatsApp.",
      items: [
        "Notes de cours avec points de focus par séance",
        "Objectifs à long terme + jalons",
        "Import vidéo avec commentaires par code temporel",
        "Scan reprise KNHS/FEI avec scores",
        "Commentaires de jury liés à l'entraînement",
        "Résultats de concours et tendance EPI",
        "Contact client et historique des cours",
        "Carnet de cours / abonnement / factures",
        "Graphique de progression par discipline",
        "Accès partagé avec le propriétaire du cheval",
      ],
      ctaLabel: "Découvrir le module entraîneur",
      ctaHref: "/trainer",
    },
    beforeAfter: {
      title: "De WhatsApp + YouTube à EquiSight Trainer.",
      lead: "Concrètement : voici comment votre workflow de coaching évolue.",
      rows: [
        {
          before: "WhatsApp avec des liens vidéo éparpillés",
          after: "Vidéo avec retour par code temporel dans le dossier",
        },
        {
          before: "Carnet de notes par cavalier",
          after: "Journal de coaching avec objectifs + historique",
        },
        {
          before: "Excel avec scores de concours",
          after: "Graphique EPI + analyse de reprise",
        },
        {
          before: "Objectifs formulés à l'oral",
          after: "Jalons avec indicateur de progression",
        },
        {
          before: "Outil de facturation séparé",
          after: "Cours + iDEAL + abonnement dans l'application",
        },
        {
          before: "E-mail au propriétaire sur la progression",
          after: "Le propriétaire suit dans sa propre vue",
        },
      ],
    },
    helper: {
      title: "Quelle application entraîneur vous correspond ?",
      lead: "5 questions pour savoir si un outil de coaching spécialisé apporte une valeur ajoutée à votre pratique.",
      questions: [
        {
          id: "clients",
          q: "Combien de binômes actifs coachez-vous ?",
          options: [
            {
              label: "Moins de 5",
              score: 1,
            },
            {
              label: "5-15",
              score: 2,
            },
            {
              label: "Plus de 15",
              score: 3,
            },
          ],
        },
        {
          id: "discipline",
          q: "Quelle est votre discipline principale ?",
          options: [
            {
              label: "Dressage",
              score: 3,
            },
            {
              label: "Saut d'obstacles",
              score: 2,
            },
            {
              label: "Récréatif / divers",
              score: 1,
            },
          ],
        },
        {
          id: "video",
          q: "Utilisez-vous la vidéo dans votre coaching ?",
          options: [
            {
              label: "Rarement",
              score: 0,
            },
            {
              label: "Parfois (manuellement)",
              score: 2,
            },
            {
              label: "Souvent — de façon structurée",
              score: 3,
            },
          ],
        },
        {
          id: "comp",
          q: "Coachez-vous des cavaliers de compétition ?",
          options: [
            {
              label: "Non, récréatif",
              score: 0,
            },
            {
              label: "Quelques concours",
              score: 2,
            },
            {
              label: "Beaucoup — les engagements sont au centre",
              score: 3,
            },
          ],
        },
        {
          id: "depth",
          q: "Souhaitez-vous mesurer votre coaching ?",
          options: [
            {
              label: "Non, l'intuition suffit",
              score: 0,
            },
            {
              label: "Oui, mais je n'ai pas le temps",
              score: 2,
            },
            {
              label: "Oui — coaching basé sur les données",
              score: 3,
            },
          ],
        },
      ],
      results: {
        low: {
          title: "Un outil simple, voire WhatsApp, suffit — pour l'instant.",
          body: "Pour moins de 5 cavaliers sans beaucoup de vidéo ni de concours, une application de coaching est superflue. EquiSight démarre gratuitement, vous pouvez donc l'essayer quand votre pratique se développe.",
          cta: "Commencer gratuitement",
        },
        mid: {
          title: "EquiSight Trainer vous rend structurellement plus efficace.",
          body: "Avec 5 à 15 binômes, vous perdez chaque mois des heures dans WhatsApp et des vidéos éparpillées. EquiSight centralise tout, scanne les reprises automatiquement et permet aux cavaliers de retrouver leurs retours à tout moment.",
          cta: "Essayer le module Entraîneur",
        },
        high: {
          title: "EquiSight est conçu pour votre échelle de coaching.",
          body: "Beaucoup de cavaliers, de la vidéo, des concours et un coaching basé sur les données : c'est exactement là qu'EquiSight se démarque. EPI + scan de reprise + dossier cheval vous donnent une longueur d'avance que vos concurrents n'ont pas.",
          cta: "Planifier une démo pour votre pratique de coaching",
        },
      },
    },
    faqTitle: "Questions fréquentes sur les applications entraîneur",
    faq: [
      {
        q: "Quelle est la meilleure application entraîneur pour cheval et cavalier ?",
        a: "Pour la simple communication, de nombreux outils suffisent (même WhatsApp). Pour gérer objectifs, analyse vidéo, scan de reprise, suivi de concours et gestion des clients dans un seul outil, EquiSight est la solution la plus complète — notamment parce qu'il suit aussi le cheval lui-même, et pas seulement le binôme.",
      },
      {
        q: "EquiSight peut-il lire automatiquement les reprises de concours ?",
        a: "Oui. Importez une reprise KNHS ou FEI et EquiSight extrait les scores par élément, les commentaires de jury et les associe au binôme. Vous visualisez les tendances sur plusieurs concours.",
      },
      {
        q: "Qu'est-ce que l'EPI (Equestrian Performance Index) ?",
        a: "L'EPI est un score EquiSight qui convertit plusieurs résultats de concours en un indice de performance comparable. Vous visualisez ainsi la réelle progression à travers différentes classes et jurys.",
      },
      {
        q: "Les cavaliers peuvent-ils réserver et payer mes cours eux-mêmes ?",
        a: "Oui. Les cavaliers se connectent, voient les créneaux disponibles, achètent des carnets de cours et paient via iDEAL. Vous contrôlez ce que vous souhaitez proposer.",
      },
      {
        q: "Fonctionne-t-il aussi pour un instructeur qui travaille autour d'un centre équestre ?",
        a: "Oui. Vous pouvez travailler en tant qu'entraîneur indépendant avec vos propres clients sans associer un compte de centre équestre. Les clients vous paient directement.",
      },
      {
        q: "Puis-je migrer mes vidéos et notes existantes ?",
        a: "Les vidéos peuvent être importées par binôme ou via un outil d'import en lot. Les notes s'importent via CSV. Nous accompagnons les entraîneurs actifs avec une migration unique.",
      },
    ],
  },
  gidsen: {
    seo: {
      title: "Guides & outils de sélection pour logiciel de gestion équestre | EquiSight",
      description: "Tous les guides EquiSight en un seul endroit : gestion équestre, élevage, manège et comparaisons de logiciels pour entraîneurs, plus des outils de sélection pour 2026.",
      keywords: [
        "guides logiciel équestre",
        "aide au choix gestion équestre",
        "comparer logiciel élevage équin",
        "guide logiciel manège",
        "comparaison application entraîneur",
      ],
    },
    hub: {
      eyebrow: "Hub · guides",
      breadcrumbLabel: "Guides",
      title: "Quatre guides complets pour choisir le bon logiciel équestre.",
      intro: "Un outil de sélection approfondi pour chaque profil : tableaux comparatifs, critères, exemples et quiz interactif. Cliquez sur le guide qui correspond à votre situation, ou explorez d'abord les articles approfondis sous chaque cluster.",
      stats: {
        guides: "4 outils de sélection",
        articles: "15 articles approfondis",
        fair: "Comparaison honnête",
      },
      readMoreCta: "Lire le guide complet",
      relatedHeading: "Articles approfondis",
      articlesCountSingular: "{{count}} article approfondi",
      articlesCountPlural: "{{count}} articles approfondis",
      articlesCountAria: "Nombre d'articles du cluster",
      lastUpdatedPrefix: "Mis à jour",
      lastUpdatedAria: "Date de dernière mise à jour de ce cluster",
    },
    clusters: [
      {
        path: "/beste-paardenbeheer-app",
        icon: "Compass",
        title: "Outil de sélection : application de gestion équestre",
        blurb: "Comparez les applications de gestion équestre les plus connues et découvrez celle qui convient au propriétaire, à l'écurie ou à l'élevage. Inclut un tableau comparatif honnête et un outil de sélection en 5 questions.",
        audience: "Pour les propriétaires, les gérants d'écuries et tous les passionnés de chevaux en quête de clarté.",
      },
      {
        path: "/fokkerij-software-paard",
        icon: "Baby",
        title: "Comparaison de logiciels d'élevage équin",
        blurb: "Du cycle de la jument au développement du poulain : découvrez quel logiciel d'élevage fonctionne vraiment selon votre nombre de juments, votre méthode d'élevage et les exigences du stud-book.",
        audience: "Pour les éleveurs (amateurs et professionnels), les haras et les détenteurs d'étalons.",
      },
      {
        path: "/manege-software",
        icon: "Building2",
        title: "Outil de sélection : logiciel de manège",
        blurb: "Planification des cours, administration des cavaliers, portail propriétaire et facturation — dans un seul outil. Comparez les options pour les manèges et les écuries de pension en 2026.",
        audience: "Pour les manèges, les écuries de pension et les centres équestres.",
      },
      {
        path: "/trainer-app-paard",
        icon: "Target",
        title: "Outil de sélection : application pour entraîneur",
        blurb: "CRM de coaching, retours vidéo, analyse du protocole KNHS et objectifs par combinaison. Quelle application entraîneur correspond à votre pratique de coaching ?",
        audience: "Pour les instructeurs, les entraîneurs et les coaches.",
      },
    ],
    closing: {
      eyebrow: "Pourquoi ces guides",
      title: "Comparer honnêtement, pas seulement les prix.",
      body1: "De nombreuses « pages de comparaison » sont en réalité des publicités déguisées. Nos guides mettent côte à côte les fonctionnalités, le public cible et les concurrents, comme le ferait une source d'information indépendante. EquiSight ressort naturellement comme la solution complète, mais vous lirez aussi honnêtement là où d'autres applications sont plus performantes.",
      body2: "Les articles approfondis sous chaque guide répondent aux questions concrètes qui découlent du choix : « Quand faire la première échographie après insémination », « Comment automatiser la facturation du manège », « Comment analyser un protocole de compétition ». Pas de discours marketing creux, mais de la pratique.",
    },
    hubName: "Guides EquiSight",
  },
  ui: {
    sectionEyebrows: {
      pains: "Pourquoi c'est problématique",
      basics: "L'essentiel",
      criteria: "Qu'est-ce qui fait la différence ?",
      comparison: "Comparaison honnête",
      why: "La différence",
      beforeAfter: "De la dispersion à la clarté",
      helper: "5 questions",
    },
    table: {
      feature: "Fonctionnalité",
      today: "Aujourd'hui",
      withEquisight: "Avec EquiSight",
    },
    helper: {
      questionLabel: "Question {{current}} sur {{total}}",
      answerPrompt: "Répondez à la {{count}} question restante pour voir une recommandation.",
      answerPromptPlural: "Répondez aux {{count}} questions restantes pour voir une recommandation.",
      resultEyebrow: "Votre résultat",
    },
    targetGroupsFallback: "Pour qui est-ce destiné ?",
    faqTitleFallback: "Questions fréquemment posées",
  },
};

export default CORNERSTONES;
